/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OccupancyHoursEnum } from '../models/OccupancyHoursEnum'
import type { Page_ParkingCountsForRateChangeTargetResponse_ } from '../models/Page_ParkingCountsForRateChangeTargetResponse_'
import type { Page_ParkingCountsResponse_ } from '../models/Page_ParkingCountsResponse_'
import type { ParkingCountsAggregatedResponse } from '../models/ParkingCountsAggregatedResponse'
import type { ParkingOperatorDataType } from '../models/ParkingOperatorDataType'
import type { PaymentTypeEnum } from '../models/PaymentTypeEnum'
import type { CancelablePromise } from '../core/CancelablePromise'
import type { BaseHttpRequest } from '../core/BaseHttpRequest'
export class PricingEngineService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Get Parking Counts For Occupancy Target
   * Returns actual and test parking counts by shape in a standard list format.
   * @returns Page_ParkingCountsResponse_ Successful Response
   * @throws ApiError
   */
  public getParkingCountsForOccupancyTarget({
    regionId,
    shapeLayerUuid,
    startDate,
    endDate,
    lowerTargetOccupancy,
    upperTargetOccupancy,
    maxRateChange,
    priceElasticity,
    orderBy = '+shape_name',
    page = 1,
    size = 50,
    startTime,
    endTime,
    daysOfWeek,
    operators,
    paymentTypes,
    shapeUuids,
    dataType,
    hours,
  }: {
    /**
     * Region identifier
     */
    regionId: string
    /**
     * Layer identifier
     */
    shapeLayerUuid: string
    /**
     * Filter for records that end after the provided ISO start date
     */
    startDate: string
    /**
     * Filter for records that start on or before the provided ISO end date
     */
    endDate: string
    /**
     * Lower target limit for calculating the rate change
     */
    lowerTargetOccupancy: number
    /**
     * Upper target limit for calculating the rate change
     */
    upperTargetOccupancy: number
    /**
     * The max dollar amount by which the hourly parking rate can change
     */
    maxRateChange: number
    /**
     * Used for calculating the occupancy effect of a rate change
     */
    priceElasticity: number
    /**
     * metric to sort the results by, prepended by - (desc) or + (asc)
     */
    orderBy?: string
    page?: number
    size?: number
    /**
     * Filter for records that end after the provided ISO start time
     */
    startTime?: number | null
    /**
     * Filter for records that start on or before the provided ISO start time
     */
    endTime?: number | null
    /**
     * Filter for days of week
     */
    daysOfWeek?: Array<number> | null
    /**
     * Filter for records that are in this list of operators
     */
    operators?: Array<string> | null
    /**
     * Filter for records that are in this list of payment types
     */
    paymentTypes?: Array<PaymentTypeEnum> | null
    /**
     * Filter for one or more shapes or districts
     */
    shapeUuids?: Array<string> | null
    /**
     * Selector for payments or sensor based occupancy
     */
    dataType?: ParkingOperatorDataType | null
    /**
     * Enforced hours or all hours for occupancy supply
     */
    hours?: OccupancyHoursEnum | null
  }): CancelablePromise<Page_ParkingCountsResponse_> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/layers/{shape_layer_uuid}/pricing_engine/occupancy_target',
      path: {
        region_id: regionId,
        shape_layer_uuid: shapeLayerUuid,
      },
      query: {
        order_by: orderBy,
        page: page,
        size: size,
        start_date: startDate,
        end_date: endDate,
        start_time: startTime,
        end_time: endTime,
        days_of_week: daysOfWeek,
        operators: operators,
        payment_types: paymentTypes,
        shape_uuids: shapeUuids,
        data_type: dataType,
        hours: hours,
        lower_target_occupancy: lowerTargetOccupancy,
        upper_target_occupancy: upperTargetOccupancy,
        max_rate_change: maxRateChange,
        price_elasticity: priceElasticity,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Parking Counts For Occupancy Target Vector
   * Generates vector tiles for pricing engine data, split by shape.
   * @returns string Successful Response
   * @throws ApiError
   */
  public getParkingCountsForOccupancyTargetVector({
    regionId,
    shapeLayerUuid,
    z,
    x,
    y,
    startDate,
    endDate,
    lowerTargetOccupancy,
    upperTargetOccupancy,
    maxRateChange,
    priceElasticity,
    startTime,
    endTime,
    daysOfWeek,
    operators,
    paymentTypes,
    shapeUuids,
    dataType,
    hours,
    ifModifiedSince,
  }: {
    /**
     * Region identifier
     */
    regionId: string
    /**
     * Layer identifier
     */
    shapeLayerUuid: string
    z: number
    x: number
    y: number
    /**
     * Filter for records that end after the provided ISO start date
     */
    startDate: string
    /**
     * Filter for records that start on or before the provided ISO end date
     */
    endDate: string
    /**
     * Lower target limit for calculating the rate change
     */
    lowerTargetOccupancy: number
    /**
     * Upper target limit for calculating the rate change
     */
    upperTargetOccupancy: number
    /**
     * The max dollar amount by which the hourly parking rate can change
     */
    maxRateChange: number
    /**
     * Used for calculating the occupancy effect of a rate change
     */
    priceElasticity: number
    /**
     * Filter for records that end after the provided ISO start time
     */
    startTime?: number | null
    /**
     * Filter for records that start on or before the provided ISO start time
     */
    endTime?: number | null
    /**
     * Filter for days of week
     */
    daysOfWeek?: Array<number> | null
    /**
     * Filter for records that are in this list of operators
     */
    operators?: Array<string> | null
    /**
     * Filter for records that are in this list of payment types
     */
    paymentTypes?: Array<PaymentTypeEnum> | null
    /**
     * Filter for one or more shapes or districts
     */
    shapeUuids?: Array<string> | null
    /**
     * Selector for payments or sensor based occupancy
     */
    dataType?: ParkingOperatorDataType | null
    /**
     * Enforced hours or all hours for occupancy supply
     */
    hours?: OccupancyHoursEnum | null
    ifModifiedSince?: string | null
  }): CancelablePromise<string> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/layers/{shape_layer_uuid}/pricing_engine/occupancy_target/vector/{z}/{x}/{y}',
      path: {
        region_id: regionId,
        shape_layer_uuid: shapeLayerUuid,
        z: z,
        x: x,
        y: y,
      },
      query: {
        start_date: startDate,
        end_date: endDate,
        start_time: startTime,
        end_time: endTime,
        days_of_week: daysOfWeek,
        operators: operators,
        payment_types: paymentTypes,
        shape_uuids: shapeUuids,
        data_type: dataType,
        hours: hours,
        lower_target_occupancy: lowerTargetOccupancy,
        upper_target_occupancy: upperTargetOccupancy,
        max_rate_change: maxRateChange,
        price_elasticity: priceElasticity,
        if_modified_since: ifModifiedSince,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Parking Counts For Occupancy Target Aggregated
   * Returns actual and test parking counts aggregated for a layer.
   * @returns ParkingCountsAggregatedResponse Successful Response
   * @throws ApiError
   */
  public getParkingCountsForOccupancyTargetAggregated({
    regionId,
    shapeLayerUuid,
    startDate,
    endDate,
    lowerTargetOccupancy,
    upperTargetOccupancy,
    maxRateChange,
    priceElasticity,
    startTime,
    endTime,
    daysOfWeek,
    operators,
    paymentTypes,
    shapeUuids,
    dataType,
    hours,
  }: {
    /**
     * Region identifier
     */
    regionId: string
    /**
     * Layer identifier
     */
    shapeLayerUuid: string
    /**
     * Filter for records that end after the provided ISO start date
     */
    startDate: string
    /**
     * Filter for records that start on or before the provided ISO end date
     */
    endDate: string
    /**
     * Lower target limit for calculating the rate change
     */
    lowerTargetOccupancy: number
    /**
     * Upper target limit for calculating the rate change
     */
    upperTargetOccupancy: number
    /**
     * The max dollar amount by which the hourly parking rate can change
     */
    maxRateChange: number
    /**
     * Used for calculating the occupancy effect of a rate change
     */
    priceElasticity: number
    /**
     * Filter for records that end after the provided ISO start time
     */
    startTime?: number | null
    /**
     * Filter for records that start on or before the provided ISO start time
     */
    endTime?: number | null
    /**
     * Filter for days of week
     */
    daysOfWeek?: Array<number> | null
    /**
     * Filter for records that are in this list of operators
     */
    operators?: Array<string> | null
    /**
     * Filter for records that are in this list of payment types
     */
    paymentTypes?: Array<PaymentTypeEnum> | null
    /**
     * Filter for one or more shapes or districts
     */
    shapeUuids?: Array<string> | null
    /**
     * Selector for payments or sensor based occupancy
     */
    dataType?: ParkingOperatorDataType | null
    /**
     * Enforced hours or all hours for occupancy supply
     */
    hours?: OccupancyHoursEnum | null
  }): CancelablePromise<ParkingCountsAggregatedResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/layers/{shape_layer_uuid}/pricing_engine/occupancy_target_aggregated',
      path: {
        region_id: regionId,
        shape_layer_uuid: shapeLayerUuid,
      },
      query: {
        start_date: startDate,
        end_date: endDate,
        start_time: startTime,
        end_time: endTime,
        days_of_week: daysOfWeek,
        operators: operators,
        payment_types: paymentTypes,
        shape_uuids: shapeUuids,
        data_type: dataType,
        hours: hours,
        lower_target_occupancy: lowerTargetOccupancy,
        upper_target_occupancy: upperTargetOccupancy,
        max_rate_change: maxRateChange,
        price_elasticity: priceElasticity,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Parking Counts For Rate Target
   * Returns actual and test parking counts using by shape rate change targets to
   * make the test calculations.
   * @returns Page_ParkingCountsForRateChangeTargetResponse_ Successful Response
   * @throws ApiError
   */
  public getParkingCountsForRateTarget({
    regionId,
    shapeLayerUuid,
    startDate,
    endDate,
    priceElasticity,
    orderBy = '+shape_name',
    page = 1,
    size = 50,
    startTime,
    endTime,
    daysOfWeek,
    operators,
    paymentTypes,
    shapeUuids,
    dataType,
    hours,
    rates,
  }: {
    /**
     * Region identifier
     */
    regionId: string
    /**
     * Layer identifier
     */
    shapeLayerUuid: string
    /**
     * Filter for records that end after the provided ISO start date
     */
    startDate: string
    /**
     * Filter for records that start on or before the provided ISO end date
     */
    endDate: string
    /**
     * Used for calculating the occupancy effect of a rate change
     */
    priceElasticity: number
    /**
     * metric to sort the results by, prepended by - (desc) or + (asc)
     */
    orderBy?: string
    page?: number
    size?: number
    /**
     * Filter for records that end after the provided ISO start time
     */
    startTime?: number | null
    /**
     * Filter for records that start on or before the provided ISO start time
     */
    endTime?: number | null
    /**
     * Filter for days of week
     */
    daysOfWeek?: Array<number> | null
    /**
     * Filter for records that are in this list of operators
     */
    operators?: Array<string> | null
    /**
     * Filter for records that are in this list of payment types
     */
    paymentTypes?: Array<PaymentTypeEnum> | null
    /**
     * List of shape UUIDs for which alternative rates are being calculated. This should be a list of the same length and ordered to match the rates.
     */
    shapeUuids?: Array<string> | null
    /**
     * Selector for payments or sensor based occupancy
     */
    dataType?: ParkingOperatorDataType | null
    /**
     * Enforced hours or all hours for occupancy supply
     */
    hours?: OccupancyHoursEnum | null
    /**
     * The dollar amount by which the hourly parking rate should change for a given shape. This should be a list of the same length and ordered to match the shape_uuids.
     */
    rates?: Array<number> | null
  }): CancelablePromise<Page_ParkingCountsForRateChangeTargetResponse_> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/layers/{shape_layer_uuid}/pricing_engine/rate_target',
      path: {
        region_id: regionId,
        shape_layer_uuid: shapeLayerUuid,
      },
      query: {
        order_by: orderBy,
        page: page,
        size: size,
        start_date: startDate,
        end_date: endDate,
        start_time: startTime,
        end_time: endTime,
        days_of_week: daysOfWeek,
        operators: operators,
        payment_types: paymentTypes,
        shape_uuids: shapeUuids,
        data_type: dataType,
        hours: hours,
        price_elasticity: priceElasticity,
        rates: rates,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Parking Counts For Rate Target Aggregated
   * Returns actual and test parking counts aggregated for a layer.
   * @returns ParkingCountsAggregatedResponse Successful Response
   * @throws ApiError
   */
  public getParkingCountsForRateTargetAggregated({
    regionId,
    shapeLayerUuid,
    startDate,
    endDate,
    priceElasticity,
    startTime,
    endTime,
    daysOfWeek,
    operators,
    paymentTypes,
    shapeUuids,
    dataType,
    hours,
    rates,
  }: {
    /**
     * Region identifier
     */
    regionId: string
    /**
     * Layer identifier
     */
    shapeLayerUuid: string
    /**
     * Filter for records that end after the provided ISO start date
     */
    startDate: string
    /**
     * Filter for records that start on or before the provided ISO end date
     */
    endDate: string
    /**
     * Used for calculating the occupancy effect of a rate change
     */
    priceElasticity: number
    /**
     * Filter for records that end after the provided ISO start time
     */
    startTime?: number | null
    /**
     * Filter for records that start on or before the provided ISO start time
     */
    endTime?: number | null
    /**
     * Filter for days of week
     */
    daysOfWeek?: Array<number> | null
    /**
     * Filter for records that are in this list of operators
     */
    operators?: Array<string> | null
    /**
     * Filter for records that are in this list of payment types
     */
    paymentTypes?: Array<PaymentTypeEnum> | null
    /**
     * List of shape UUIDs for which alternative rates are being calculated. This should be a list of the same length and ordered to match the rates.
     */
    shapeUuids?: Array<string> | null
    /**
     * Selector for payments or sensor based occupancy
     */
    dataType?: ParkingOperatorDataType | null
    /**
     * Enforced hours or all hours for occupancy supply
     */
    hours?: OccupancyHoursEnum | null
    /**
     * The dollar amount by which the hourly parking rate should change for a given shape. This should be a list of the same length and ordered to match the shape_uuids.
     */
    rates?: Array<number> | null
  }): CancelablePromise<ParkingCountsAggregatedResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/layers/{shape_layer_uuid}/pricing_engine/rate_target_aggregated',
      path: {
        region_id: regionId,
        shape_layer_uuid: shapeLayerUuid,
      },
      query: {
        start_date: startDate,
        end_date: endDate,
        start_time: startTime,
        end_time: endTime,
        days_of_week: daysOfWeek,
        operators: operators,
        payment_types: paymentTypes,
        shape_uuids: shapeUuids,
        data_type: dataType,
        hours: hours,
        price_elasticity: priceElasticity,
        rates: rates,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Parking Counts For Rate Target Vector
   * Generates vector tiles for pricing engine data, split by shape.
   * @returns string Successful Response
   * @throws ApiError
   */
  public getParkingCountsForRateTargetVector({
    regionId,
    shapeLayerUuid,
    z,
    x,
    y,
    startDate,
    endDate,
    priceElasticity,
    startTime,
    endTime,
    daysOfWeek,
    operators,
    paymentTypes,
    shapeUuids,
    dataType,
    hours,
    rates,
    ifModifiedSince,
  }: {
    /**
     * Region identifier
     */
    regionId: string
    /**
     * Layer identifier
     */
    shapeLayerUuid: string
    z: number
    x: number
    y: number
    /**
     * Filter for records that end after the provided ISO start date
     */
    startDate: string
    /**
     * Filter for records that start on or before the provided ISO end date
     */
    endDate: string
    /**
     * Used for calculating the occupancy effect of a rate change
     */
    priceElasticity: number
    /**
     * Filter for records that end after the provided ISO start time
     */
    startTime?: number | null
    /**
     * Filter for records that start on or before the provided ISO start time
     */
    endTime?: number | null
    /**
     * Filter for days of week
     */
    daysOfWeek?: Array<number> | null
    /**
     * Filter for records that are in this list of operators
     */
    operators?: Array<string> | null
    /**
     * Filter for records that are in this list of payment types
     */
    paymentTypes?: Array<PaymentTypeEnum> | null
    /**
     * List of shape UUIDs for which alternative rates are being calculated. This should be a list of the same length and ordered to match the rates.
     */
    shapeUuids?: Array<string> | null
    /**
     * Selector for payments or sensor based occupancy
     */
    dataType?: ParkingOperatorDataType | null
    /**
     * Enforced hours or all hours for occupancy supply
     */
    hours?: OccupancyHoursEnum | null
    /**
     * The dollar amount by which the hourly parking rate should change for a given shape. This should be a list of the same length and ordered to match the shape_uuids.
     */
    rates?: Array<number> | null
    ifModifiedSince?: string | null
  }): CancelablePromise<string> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/layers/{shape_layer_uuid}/pricing_engine/rate_target/vector/{z}/{x}/{y}',
      path: {
        region_id: regionId,
        shape_layer_uuid: shapeLayerUuid,
        z: z,
        x: x,
        y: y,
      },
      query: {
        start_date: startDate,
        end_date: endDate,
        start_time: startTime,
        end_time: endTime,
        days_of_week: daysOfWeek,
        operators: operators,
        payment_types: paymentTypes,
        shape_uuids: shapeUuids,
        data_type: dataType,
        hours: hours,
        price_elasticity: priceElasticity,
        rates: rates,
        if_modified_since: ifModifiedSince,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
}
